export default (() => {
  return {
    get: (cname) => {
      let name = cname + "="
      let decodedCookie = decodeURIComponent(document.cookie)
      let ca = decodedCookie.split(';')
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ""
    },
    set: ({ cname, cvalue, exdays= 1 }) => {
      const domain = process.env.NODE_ENV === 'development' ? 'localhost' : 'sahapat.com'
      // const d = new Date();
      // d.setTime(d.getTime() + (exdays*24*60*60*1000))
      /* Set ให้ Cookie หมดอายุทุกเที่ยงคืนของทุกวัน */
      const exdate=new Date();
      exdate.setHours(23);
      exdate.setMinutes(59);
      exdate.setSeconds(59);
      let expires = `expires=${exdate.toUTCString()}`
      document.cookie = `${cname}=${cvalue};${expires};path=/; domain=${domain};`
    }
  }
})()